import ElAutocomplete from './src/autocomplete.vue';

/* istanbul ignore next */
(ElAutocomplete as any).install = function(Vue: any) {
  Vue.component(ElAutocomplete.name, ElAutocomplete);
};

export default ElAutocomplete;
